import { _ as _tagged_template_literal } from "@swc/helpers/_/_tagged_template_literal";
function _templateObject() {
    const data = _tagged_template_literal([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 32px;\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _tagged_template_literal([
        "\n  display: flex;\n  width: 100%;\n  height: 48px;\n  background-color: ",
        ";\n  border-radius: 6px;\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = _tagged_template_literal([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = _tagged_template_literal([
        "\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  p {\n    display: flex;\n    gap: 4px;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 24px; /* 150% */\n    letter-spacing: -0.16px;\n    color: ",
        ";\n    span {\n      color: ",
        ";\n    }\n  }\n\n  button {\n    all: unset;\n    font-size: 16px;\n    font-weight: 400;\n    line-height: 24px; /* 150% */\n    letter-spacing: -0.16px;\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = _tagged_template_literal([
        "\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n\n  padding: 20px;\n  border-radius: 6px;\n  background-color: ",
        ";\n\n  p {\n  }\n"
    ]);
    _templateObject4 = function() {
        return data;
    };
    return data;
}
function _templateObject5() {
    const data = _tagged_template_literal([
        ""
    ]);
    _templateObject5 = function() {
        return data;
    };
    return data;
}
function _templateObject6() {
    const data = _tagged_template_literal([
        "\n  font-size: 20px;\n  font-weight: 600;\n  line-height: 30px; /* 150% */\n  letter-spacing: -0.2px;\n  color: ",
        ";\n"
    ]);
    _templateObject6 = function() {
        return data;
    };
    return data;
}
function _templateObject7() {
    const data = _tagged_template_literal([
        "\n  display: flex;\n  justify-content: center;\n"
    ]);
    _templateObject7 = function() {
        return data;
    };
    return data;
}
function _templateObject8() {
    const data = _tagged_template_literal([
        "\n  all: unset;\n  width: 340px;\n\n  text-align: center;\n  padding: 12px 16px;\n  border-radius: 6px;\n  border: 1px solid ",
        ";\n  color: ",
        ";\n  font-weight: 600;\n  cursor: pointer;\n\n  :hover {\n    background-color: rgba(169, 175, 199, 0.2);\n    border: 1px solid ",
        ";\n  }\n\n  @media (max-width: 768px) {\n    width: 100%;\n  }\n"
    ]);
    _templateObject8 = function() {
        return data;
    };
    return data;
}
function _templateObject9() {
    const data = _tagged_template_literal([
        "\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 24px;\n  color: ",
        ";\n\n  padding: 25px 0;\n"
    ]);
    _templateObject9 = function() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { mixpanelEvent } from "@/lib/mixpanels/mixpanel";
import { useInfiniteQuery } from "@tanstack/react-query";
import { useRouter } from "next/router";
import { useCallback, useEffect, useMemo, useState } from "react";
import { getReviews } from "src/api/review";
import useHandoutProductStore from "src/store/relatedProduct";
import styled from "styled-components";
import { ProductRating } from "..";
import { Segment } from "../../common/Segment";
import { Sizes } from "../../icon/IconList";
import Dialog from "./Dialog";
import ReviewRow from "./ReviewRow";
import useReviewHandler from "./useReviewHandler";
var ReviewType;
(function(ReviewType) {
    ReviewType["PRODUCT"] = "product";
    ReviewType["AUTHOR"] = "author";
})(ReviewType || (ReviewType = {}));
const ReviewTabString = {
    [ReviewType.PRODUCT]: "이 자료의 후기",
    [ReviewType.AUTHOR]: "저자의 다른 후기"
};
const segmentOptions = [
    {
        label: ReviewTabString[ReviewType.PRODUCT],
        value: ReviewType.PRODUCT
    },
    {
        label: ReviewTabString[ReviewType.AUTHOR],
        value: ReviewType.AUTHOR
    }
];
const LIMIT = 5;
const Review = (param)=>{
    let { productItem  } = param;
    const { asPath  } = useRouter();
    const { hasReview , setHasReview , setRating  } = useHandoutProductStore((state)=>({
            hasReview: state.hasReview,
            setHasReview: state.setHasReview,
            setRating: state.setRating
        }));
    const [tabStatus, setTabStatus] = useState(ReviewType.PRODUCT);
    const [reviewTypeCount, setReviewTypeCount] = useState(null);
    const [handleReviewHelpCountClick, handleDeleteReview, , reviewStatus, , setModalProps, setDeleteReviewId] = useReviewHandler(productItem);
    const handleReviewType = useCallback((type)=>{
        setTabStatus(type);
        mixpanelEvent("Tab UI Clicked", {
            //mx-108
            "Tab Type": "Review Type",
            "Tab Name": type === ReviewType.PRODUCT ? "이 자료의 후기" : "저자의 다른 후기"
        });
    }, [
        setTabStatus
    ]);
    const searchPath = useMemo(()=>{
        const splitPath = asPath.split("/");
        return splitPath[splitPath.length - 1];
    }, [
        asPath
    ]);
    const { data: reviewResponse , fetchNextPage , hasNextPage  } = useInfiniteQuery([
        "getReviews",
        tabStatus,
        searchPath
    ], (param)=>{
        let { pageParam =0  } = param;
        return getReviews({
            id: tabStatus === ReviewType.PRODUCT ? searchPath : String(productItem.author_id),
            type: tabStatus,
            pagination: {
                offset: pageParam,
                limit: LIMIT
            }
        });
    }, {
        getNextPageParam: (lastPage)=>{
            const { offset , total  } = lastPage.pagination;
            if (offset + LIMIT >= total) return undefined;
            return offset + LIMIT;
        },
        onError: (error)=>{
            ;
        }
    });
    useEffect(()=>{
        // 자료 후기가 없는데 저자 후기가 있는경우 탭 변경 및 리뷰 타입 상태 저장
        if (!reviewResponse) return;
        const totalCount = reviewResponse === null || reviewResponse === void 0 ? void 0 : reviewResponse.pages[0].pagination.total;
        if (totalCount === 0 && reviewTypeCount === null) {
            setReviewTypeCount({
                type: ReviewType.PRODUCT,
                count: totalCount
            });
            setTabStatus(ReviewType.AUTHOR);
        }
    }, [
        reviewResponse
    ]);
    useEffect(()=>{
        // 자료 후기도 없고 저자 후기도 없는경우 후기 섹션 안보이게
        if (!reviewTypeCount) return;
        if (reviewTypeCount.type === "product" && reviewTypeCount.count === 0 && tabStatus === ReviewType.AUTHOR && (reviewResponse === null || reviewResponse === void 0 ? void 0 : reviewResponse.pages[0].pagination.total) === 0) {
            setHasReview(false);
        }
    }, [
        reviewTypeCount,
        setHasReview,
        reviewResponse
    ]);
    useEffect(()=>{
        if (reviewResponse && tabStatus === ReviewType.PRODUCT) {
            setRating(reviewResponse.pages[0].averageRating);
        }
    }, [
        reviewResponse,
        tabStatus
    ]);
    // if (!reviewResponse) return null 맨 처음 렌더링 할 때, 가리기 위해서 추가했지만 탭을 전환하는 그 사이에 후기가 ㅆㅏ악 다 사라지는 이슈로 일단 보류
    return /*#__PURE__*/ _jsxs(ReviewBox, {
        children: [
            reviewStatus && reviewStatus.type && /*#__PURE__*/ _jsx(Dialog, {
                ...setModalProps()
            }),
            /*#__PURE__*/ _jsx(Tab, {
                children: /*#__PURE__*/ _jsx(Segment, {
                    onChange: handleReviewType,
                    value: tabStatus,
                    options: segmentOptions,
                    onResize: null,
                    onResizeCapture: null
                })
            }),
            /*#__PURE__*/ _jsxs(ReviewCountingInfo, {
                children: [
                    /*#__PURE__*/ _jsxs(ReviewFiltering, {
                        children: [
                            /*#__PURE__*/ _jsxs("p", {
                                children: [
                                    "후기",
                                    /*#__PURE__*/ _jsx("span", {
                                        children: (reviewResponse === null || reviewResponse === void 0 ? void 0 : reviewResponse.pages[0].pagination.total) || 0
                                    })
                                ]
                            }),
                            (reviewResponse === null || reviewResponse === void 0 ? void 0 : reviewResponse.pages[0].pagination.total) > 0 && /*#__PURE__*/ _jsx("button", {
                                children: "작성일순"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx(RatingArea, {
                        children: !(reviewResponse === null || reviewResponse === void 0 ? void 0 : reviewResponse.pages[0].pagination.total) ? tabStatus === ReviewType.PRODUCT ? /*#__PURE__*/ _jsx(DisabledReviewText, {
                            children: "아직 등록된 자료의 후기가 없어요!"
                        }) : /*#__PURE__*/ _jsx(DisabledReviewText, {
                            children: "아직 등록된 저자의 다른 후기가 없어요!"
                        }) : /*#__PURE__*/ _jsxs(_Fragment, {
                            children: [
                                /*#__PURE__*/ _jsx(StarRating, {
                                    children: /*#__PURE__*/ _jsx(ProductRating, {
                                        precision: 0.1,
                                        value: reviewResponse.pages[0].averageRating,
                                        readOnly: true,
                                        size: Sizes.large
                                    })
                                }),
                                /*#__PURE__*/ _jsxs(Average, {
                                    children: [
                                        tabStatus === ReviewType.AUTHOR ? "전체 후기 평균 " : "평균 ",
                                        (reviewResponse === null || reviewResponse === void 0 ? void 0 : reviewResponse.pages[0].averageRating) || 0,
                                        "점"
                                    ]
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                children: reviewResponse === null || reviewResponse === void 0 ? void 0 : reviewResponse.pages.map((page)=>{
                    return page.data.map((review)=>{
                        return /*#__PURE__*/ _jsx(ReviewRow, {
                            reviewItem: review,
                            mutationCount: (param)=>handleReviewHelpCountClick(param),
                            mutationDelete: (id)=>{
                                handleDeleteReview(id);
                                setDeleteReviewId(id);
                            }
                        }, review.id);
                    });
                })
            }),
            hasNextPage && /*#__PURE__*/ _jsx(ReviewButtonBox, {
                children: /*#__PURE__*/ _jsx(MoreReviewButton, {
                    onClick: ()=>{
                        fetchNextPage();
                        mixpanelEvent("More Button Clicked", {
                            //mx-116, 117
                            "Button Type": tabStatus === ReviewType.PRODUCT ? "이 자료의 후기" : "저자의 다른 후기",
                            "Button Name": "{후기 더보기}"
                        });
                    },
                    children: "후기 더보기"
                })
            })
        ]
    });
};
const ReviewBox = styled.article.withConfig({
    componentId: "sc-7cad3f5a-0"
})(_templateObject());
const Tab = styled.div.withConfig({
    componentId: "sc-7cad3f5a-1"
})(_templateObject1(), (props)=>props.theme.new.colors.sol_gray_50);
const ReviewCountingInfo = styled.div.withConfig({
    componentId: "sc-7cad3f5a-2"
})(_templateObject2());
const ReviewFiltering = styled.div.withConfig({
    componentId: "sc-7cad3f5a-3"
})(_templateObject3(), (props)=>props.theme.new.colors.sol_gray_900, (props)=>props.theme.new.colors.sol_blue_500, (props)=>props.theme.new.colors.sol_gray_700);
const RatingArea = styled.div.withConfig({
    componentId: "sc-7cad3f5a-4"
})(_templateObject4(), (props)=>props.theme.new.colors.sol_gray_0);
const StarRating = styled.div.withConfig({
    componentId: "sc-7cad3f5a-5"
})(_templateObject5());
const Average = styled.p.withConfig({
    componentId: "sc-7cad3f5a-6"
})(_templateObject6(), (props)=>props.theme.new.colors.sol_gray_900);
const ReviewButtonBox = styled.div.withConfig({
    componentId: "sc-7cad3f5a-7"
})(_templateObject7());
const MoreReviewButton = styled.button.withConfig({
    componentId: "sc-7cad3f5a-8"
})(_templateObject8(), (props)=>props.theme.new.colors.sol_gray_200, (props)=>props.theme.new.colors.sol_gray_500, (props)=>props.theme.new.colors.sol_gray_100);
const DisabledReviewText = styled.p.withConfig({
    componentId: "sc-7cad3f5a-9"
})(_templateObject9(), (props)=>props.theme.new.colors.sol_gray_500);
export default Review;
